import React, { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';

import { TableGrid } from '@C/TableGrid';
import { LoanPartyList } from '@C/Utils';
import { DateRangeFilter } from '@C/Utils';

const col = [
  {
    name: 'Date',
    key: 'time_stamp',
    sortable: true,
    type: 'date',
  },
  {
    name: 'Party name',
    key: '',
  },
  {
    name: 'Staff name',
    key: '',
  },
  {
    name: 'Principal amount',
    key: '',
  },
  {
    name: 'Interest',
    key: '',
  },
  {
    name: 'Total amount',
    key: '',
  },
  {
    name: 'Payment mode',
    key: '',
  },
  {
    name: 'Notes',
    key: '',
  },
];

const BorrowList = () => {
  const [state, setState] = useState({
    loanList: [],
    from_date: dayjs().format('YYYY-MM-DD'),
    to_date: dayjs().format('YYYY-MM-DD'),
    party_name: '',
    limit: 20,
    offset: 1,
    count: 0,
    loading: false,
  });

  const limitInput = useRef();

  useEffect(() => {
    // Add your componentDidMount logic here
  }, []);

  const submitForm = () => {
    // Add your form submission logic here
  };

  return (
    <>
      <section className="widget full-width list-table">
        <header>
          <h3> Amount received list </h3>
        </header>
        <main>
          <div className="table-filters">
            <div className="filter-wrapper">
              <div className="filter-group">
                <label>Date range:</label>
                <DateRangeFilter
                  value={[state.from_date, state.to_date]}
                  onChange={(dates) => {
                    setState((prevProps) => ({
                      ...prevProps,
                      from_date: dates[0],
                      to_date: dates[1],
                    }));
                  }}
                  limit={6}
                />
              </div>
              <div className="filter-group">
                <label> Loan party </label>
                <LoanPartyList
                  value={state.party_name}
                  onChange={(selectedParty) =>
                    setState({
                      ...state,
                      party_name: selectedParty.value || '',
                    })
                  }
                  name="party_name"
                />
              </div>
              <div className="filter-group reset-filter">
                <button
                  onClick={() => {
                    setState({
                      ...state,
                      from_date: dayjs().format('YYYY-MM-DD'),
                      to_date: dayjs().format('YYYY-MM-DD'),
                      party_name: '',
                    });
                  }}
                >
                  {' '}
                  Reset filter{' '}
                </button>
              </div>
              <div className="filter-group">
                <button
                  className={`submit ${state.loading ? 'loading' : ''}`}
                  type="submit"
                  onClick={submitForm}
                  disabled={state.loading}
                >
                  Apply filter
                </button>
              </div>
            </div>
          </div>
          <main className="content-wrapper">
            <TableGrid
              col={col}
              row={state.loanList}
              count={state.count}
              hideActions={true}
            />
          </main>
        </main>
      </section>
    </>
  );
};

export default BorrowList;
